import React from 'react'
import { Loader2 } from 'lucide-react'
import { Card } from '@/components/ui/card'
import { AuthorRow } from './AuthorRow'

export function AuthorList({ authors, loading, emptyMessage = 'No authors yet.', confirmingAuthorId, onEdit, onAskDelete, onCancelDelete, onDelete }) {
  return (
    <Card>
      <div className="flex items-center gap-4 border-b border-border px-4 py-2 text-xs font-medium text-muted-foreground">
        <div className="w-12">Image</div>
        <div className="flex-1">Author</div>
        <div className="w-40">Contact</div>
        <div className="w-[126px] text-center">Actions</div>
      </div>
      {loading ? (
        <p className="flex items-center gap-2 px-4 py-8 text-sm text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin" /> Loading authors...
        </p>
      ) : authors.length === 0 ? (
        <p className="px-4 py-8 text-sm text-muted-foreground">{emptyMessage}</p>
      ) : (
        authors.map((author) => (
          <AuthorRow
            key={author.id}
            author={author}
            confirming={confirmingAuthorId === author.id}
            onEdit={onEdit}
            onAskDelete={onAskDelete}
            onCancelDelete={onCancelDelete}
            onDelete={onDelete}
          />
        ))
      )}
    </Card>
  )
}
